export interface SwipeMomentumSample {
  quietForMs: number;
  absDeltaX: number;
  previousAbsDeltaX: number;
  previousEvidence: number;
  quietThresholdMs: number;
}

export interface SwipeMomentumDecision {
  startsNewGesture: boolean;
  evidence: number;
}

/**
 * Odróżnia malejącą końcówkę poprzedniego wheel swipe od nowego gestu.
 * Nowy gest przechodzi po wyraźnej ciszy albo po dwóch kolejnych mocno
 * rosnących próbkach. Samo momentum nie jest w stanie przesunąć nowego wiersza.
 */
export function decideSwipeMomentum(sample: SwipeMomentumSample): SwipeMomentumDecision {
  const strongAcceleration = sample.absDeltaX >= 10
    && sample.absDeltaX >= sample.previousAbsDeltaX + 5
    && sample.absDeltaX >= sample.previousAbsDeltaX * 1.35;

  let evidence = sample.previousEvidence;
  if (strongAcceleration) {
    evidence += 1;
  } else if (sample.absDeltaX <= sample.previousAbsDeltaX * 1.1) {
    evidence = 0;
  }

  return {
    startsNewGesture: sample.quietForMs >= sample.quietThresholdMs || evidence >= 2,
    evidence,
  };
}
